<agr-dialog [data]="data" (confirm)="confirm()" (cancel)="cancel()" (alt)="alt()">
  <p class="flex--row">
    <app-copy-advice-progress class="flex__child--auto"></app-copy-advice-progress>
  </p>
</agr-dialog>
